export class SolicitanteImobiliario {
  nome_solicitante: string;
  cpf: string;
  endereco: string;
  telefone: string;
  telefone_secundario: string;
  email: string;
  tipo_solicitante_id: number;
  cidade_id: number;
  cep:string;
  bairro: string;
  complemento: string;
  estado: string;
  cidade: string;
}
